import type { ReactNode } from 'react';

export const symbol_battery_android_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h620q37.5 0 63.75 26.25T840-630v300q0 37.5-26.25 63.75T750-240H130Zm170-60h450q12.75 0 21.38-8.63Q780-317.25 780-330v-300q0-12.75-8.62-21.38Q762.75-660 750-660H300v360Zm570-87v-186h20q12 0 21 9t9 21v126q0 12-9 21t-21 9h-20Z"
		/>
	</svg>
);
